import React from 'react';
import { CheckIcon } from 'lucide-react';
interface OfferItemProps {
  title: string;
  description: string;
}
export function OfferItem({
  title,
  description
}: OfferItemProps) {
  return <div className="flex gap-4 mb-6" data-id="element-248">
      <div className="flex-shrink-0 mt-1" data-id="element-249">
        <div className="w-8 h-8 rounded-full bg-brand-100 flex items-center justify-center" data-id="element-250">
          <CheckIcon className="w-5 h-5 text-brand-600" data-id="element-251" />
        </div>
      </div>
      <div data-id="element-252">
        <h4 className="font-sans font-bold text-lg text-gray-900 mb-1" data-id="element-253">
          {title}
        </h4>
        <p className="font-serif text-gray-700 leading-relaxed" data-id="element-254">
          {description}
        </p>
      </div>
    </div>;
}